import { getApps, initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  setPersistence,
  signInWithPopup,
  signOut,
  type User,
} from "firebase/auth";

type PublicFirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
};

declare global {
  interface Window {
    __ASYMMETRIC_FIREBASE_CONFIG__?: PublicFirebaseConfig;
    __ASYMMETRIC_ALLOWED_FIREBASE_EMAIL__?: string;
  }
}

const productionFirebaseConfig: PublicFirebaseConfig = {
  apiKey: "AIzaSyCNxH0dEbc_XDQodDts7CjJiyTLkxr7oTc",
  authDomain: "assymetric-1ea2b.firebaseapp.com",
  projectId: "assymetric-1ea2b",
  storageBucket: "assymetric-1ea2b.firebasestorage.app",
  messagingSenderId: "35609885156",
  appId: "1:35609885156:web:681b77099a7f161f3baff1",
};

function configuredFirebase() {
  if (typeof window === "undefined") return productionFirebaseConfig;
  return window.__ASYMMETRIC_FIREBASE_CONFIG__ ?? productionFirebaseConfig;
}

function configuredAllowedEmail() {
  if (typeof window === "undefined") return "dannytadesse709@gmail.com";
  return window.__ASYMMETRIC_ALLOWED_FIREBASE_EMAIL__?.trim().toLowerCase()
    || "dannytadesse709@gmail.com";
}

export const ALLOWED_FIREBASE_EMAIL = configuredAllowedEmail();

const firebaseConfig = configuredFirebase();
const firebaseAppName = `asymmetric-web-${firebaseConfig.projectId}`;
const firebaseApp = getApps().find((app) => app.name === firebaseAppName)
  ?? initializeApp(firebaseConfig, firebaseAppName);

export const firebaseAuth = getAuth(firebaseApp);

const persistenceReady = setPersistence(firebaseAuth, browserLocalPersistence);

function normalizedEmail(user: User | null) {
  return user?.email?.trim().toLowerCase() ?? "";
}

export function isAllowedFirebaseUser(user: User | null) {
  return Boolean(user?.emailVerified) && normalizedEmail(user) === ALLOWED_FIREBASE_EMAIL;
}

export function observeFirebaseUser(callback: (user: User | null) => void) {
  return onAuthStateChanged(firebaseAuth, callback);
}

export async function signInToAsymmetric() {
  await persistenceReady;
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  await signInWithPopup(firebaseAuth, provider);
}

export function signOutOfAsymmetric() {
  return signOut(firebaseAuth);
}

export async function firebaseIdToken() {
  const user = firebaseAuth.currentUser;
  if (!user || !isAllowedFirebaseUser(user)) {
    throw new Error("Sign in with the authorized Google account to continue.");
  }
  return user.getIdToken();
}
